import { BaseConfig } from '@red/browser';

export interface AppInfo {
    name: string;
    version: string;
    build: string;
    platform: string;
}

export interface AdWordsConversation {
    conversionId: string;
    label: string;
}

export class AppConfig extends BaseConfig {}


